/* eslint-disable max-len */
/**
 * Market Intelligence Data
 * Source: Internal performance data
 * Last refreshed: 2026-04-10
 *
 * No raw metrics exposed — only qualitative insights for operators.
 */

// ── Top games by market — populated once pxplay game codes are available ──
export const topGamesByMarket = {};

// ── Campaign suggestions — to be filled with pxplay-specific campaigns ──
export const campaignSuggestions = {};

// ── Translated campaigns per language ──
export const campaignTranslations = {};

// ── Platform stats (public-facing, rounded) ──
export const platformStats = {
  totalGames: '3',
  markets: '15+',
  operators: '200+',
  uptime: '99.9%',
};
